import { Content } from '../../types';

export const khaoSokContent: Content = {
  title: "שמורת הטבע קאו סוק ואגם צ'או לאן",
  imageUrl: '/images/thailand/khao-sok/khao-sok-wide.jpg',
  introduction: `שמורת הטבע קאו סוק הינה אחת משמורות הטבע היפות והמגוונות ביותר בתאילנד. השמורה, המשתרעת על פני כ-700 קמ"ר במחוז סוראט תאני, הינה בית ליער גשם עתיק, מגוון רחב של בעלי חיים ייחודיים, מצוקים דרמטיים ואגם צ'או לאן הקסום. בזכות הנופים המרהיבים והאפשרויות הרבות לפעילויות בטבע, המקום הפך לאטרקציה מרכזית למטיילים בתאילנד.`,
  sections: [
    {
      title: 'יער גשם עתיק ומגוון ביולוגי עשיר',
      content: `שמורת קאו סוק כוללת יער גשם עתיק, הנחשב לאחד מהיערות הטרופיים העתיקים ביותר בעולם, אף יותר מהאמזונס. זהו בית גידול לאלפי מיני צמחים ובעלי חיים, כולל פילים אסייתיים, נמרים, דובים מלאיים, קופים ממינים שונים ועוד. אחד מסמלי השמורה הוא פרח הרפלסיה, אחד הפרחים הגדולים בעולם, שיכול להגיע לקוטר של כ-80 ס"מ ונמצא בפריחתו בעיקר סביב חודש דצמבר.`,
      type: 'text-image',
      imageUrl: '/images/thailand/khao-sok/khao-sok-preview.jpg',
    },
    {
      title: 'הגעה וכניסה לשמורה',
      content: `הכניסה לשמורה היא דרך הכפר Khlong Sok, שם נמצאים מרבית בתי המלון והאכסניות המשמשים את המבקרים. בכניסה לשמורה פועל מרכז מבקרים עשיר במידע, שמספק רקע על ההיסטוריה, הגיאוגרפיה והמגוון הביולוגי של האזור.`,
      type: 'text',
    },
    {
      title: 'מסלולי טיול ואטרקציות בשמורה',
      type: 'sub-headers',
      description:
        'קאו סוק מציעה מסלולי טיול בדרגות קושי שונות, כאשר שניים מהמסלולים הפופולריים הם:',
      content: [
        {
          subtitle: "מסלול יומי במעבה הג'ונגל",
          text: 'מתאים למטיילים המחפשים חוויית טיול מאתגרת יותר, כולל מעבר דרך נהרות, תצפיות נוף מרהיבות והיתקלות אפשרית בבעלי חיים נדירים.',
        },
        {
          subtitle: 'מסלול מעגלי קצר',
          text: 'מסלול קל ונוח יותר, בו ניתן לצפות בצמחייה המגוונת ואף לראות את פרח הרפלסיה בתקופת פריחתו.',
        },
        {
          subtitle: 'טיולי לילה',
          text: 'למעוניינים לחוות את השמורה בלילה, ניתן להצטרף לסיורי לילה מיוחדים עם מדריכים מקומיים, שם ניתן לראות בעלי חיים ליליים כגון טרנטולות, עטלפים וצפרדעים זוהרות.',
        },
      ],
    },
    {
      title: "אגם צ'או לאן - פנינת השמורה",
      type: 'sub-headers',
      description:
        "אגם צ'או לאן, המשתרע על פני כ-165 קמ\"ר, הוא למעשה מאגר מים מלאכותי שנוצר בעקבות בניית סכר ראצ'אפרפה (Ratchaprapha Dam) בשנות ה-80. כיום, מהווה האגם אחת מהאטרקציות המרכזיות של השמורה, ומציע למבקרים חוויות בלתי נשכחות:",
      content: [
        {
          subtitle: 'שייט בין מצוקי הגיר',
          text: 'מצוקי גיר עצומים המזדקרים מהמים יוצרים נוף המזכיר את מפרץ הא לונג בווייטנאם.',
        },
        {
          subtitle: 'מערות מרהיבות',
          text: 'ניתן לבקר במערות כגון מערת קוראל ומערת נאם טאלו, שבהן ניתן לחקור נטיפים, זקיפים ומסלולים ייחודיים.',
        },
        {
          subtitle: 'בתי מלון צפים',
          text: 'חוויית לינה בלתי נשכחת באחד מהמלונות הצפים על פני האגם, שם ניתן להרגיש את הטבע מקרוב, לשחות במים הצלולים ולצפות בזריחות ושקיעות עוצרות נשימה.',
        },
        {
          subtitle: 'טיולי קיאקים',
          text: 'אפשרות לחוות את האגם בדרך שקטה ורגועה יותר, תוך כדי שיטוט בין המפרצונים הנסתרים וצפייה בבעלי החיים שעל גדות האגם.',
        },
        {
          subtitle: 'דיג באגם',
          text: "אגם צ'או לאן מציע גם חוויית דיג מרתקת, כאשר ניתן לנסות לתפוס מינים מקומיים של דגים במים הצלולים.",
        },
        {
          subtitle: 'ביקור בכפרים מקומיים',
          text: 'ניתן לשלב ביקור בכפרים קטנים מסביב לאגם וללמוד על אורח החיים המקומי של התושבים באזור.',
        },
      ],
    },
    {
      title: 'מתי מומלץ לבקר?',
      content: `קאו סוק נהנית מאקלים טרופי, כאשר העונה הגשומה נמשכת ממאי עד אוקטובר. העונה היבשה, מנובמבר עד אפריל, נחשבת לזמן האידיאלי לביקור, שכן מזג האוויר נעים יותר והדרכים נגישות יותר.`,
      type: 'text',
    },
    {
      title: 'בשורה התחתונה',
      content: `שמורת קאו סוק ואגם צ'או לאן הם מהאתרים המרתקים ביותר בטבע התאילנדי. עם נופים עוצרי נשימה, חיות בר מרתקות ואפשרויות טיול מגוונות - המקום מציע חוויה חד-פעמית לכל חובבי הטבע וההרפתקאות. בין אם אתם מחפשים מסלולי טיול מאתגרים, שייט רגוע או חוויית לינה ייחודית - קאו סוק הינה יעד שאסור לפספס.`,
      type: 'text',
    },
  ],
};
